module.exports = __webpack_public_path__ + "img/ic-logo.44dd728.png";